export default __webpack_public_path__ + "static/media/map.592c2dcc.webp";